import {
  Receivable_Transaction_Type,
  Receivable_Type as ReceivableTypePB,
} from "gen/txn/models_pb"

import { Decimal } from "../classes/decimal"
import { Money } from "../classes/money"
import { UUID } from "../classes/uuid"

export interface BaseReceivable {
  /** sale id for invoices, ledger entry id for credits and finance charges */
  id: UUID
  ledgerEntryId: UUID
  identifier: string
  // TODO (Nolan): leverage type intersection or discriminated union for
  // attrs that are only present on specific receivable kinds
  kind: ReceivableKind
  date: Date
  dueDate?: Date
  potentialDiscountExpiresAt?: Date
  /**  positive for charges, negative for credits */
  adjustedBalance: Money
  /** positive for charges, negative for credits */
  original: Money
  /** positive for charges, negative for credits */
  balance: Money
  /** negative */
  potentialDiscount?: Money
  /** negative */
  discounted?: Money
  /** positive for charges, negative for credits */
  allocated?: Money
  purchaseOrder?: string
  location: {
    prefix: string
    name: string
  }
  customer: {
    id: UUID
    identifier: string
    name: string
  }
  staffName: string | undefined
  job?: {
    id: UUID
    identifier: string
    name: string
  }
  statementBalance?: Money
  transaction: {
    id: UUID
    identifier: string
    type: Receivable_Transaction_Type
  }
}

export const ReceivableKinds = {
  FINANCE_CHARGE: "Finance Charge",
  INVOICE: "Invoice",
  CREDIT: "Credit",
} as const

export const ReceivableKindsPB = {
  [ReceivableKinds.FINANCE_CHARGE]: ReceivableTypePB.FINANCE_CHARGE,
  [ReceivableKinds.INVOICE]: ReceivableTypePB.INVOICE,
  [ReceivableKinds.CREDIT]: ReceivableTypePB.CREDIT,
}

export type ReceivableKind =
  (typeof ReceivableKinds)[keyof typeof ReceivableKinds]

// A bill payment's only tax is on the card surcharge; the bills it pays were
// already taxed at sale time. surchargeTax is the per-rate tax on that fee.
export interface BillTax {
  taxRateId: UUID
  name: string
  rate: Decimal
  surchargeTax: Money
  // Prebuilt display label (`${name} (${rate}%)`, or just the rate when
  // unnamed) for the per-rate display paths. Omitted on the bills-search path,
  // which only sums surchargeTax and never renders individual rates.
  label?: string
}
